import React from "react";
import { Link } from 'react-router-dom';
import logo from '../images/logo.png';


function Navbar() {
    const url = process.env.REACT_APP_SITE_URL;
    const token = sessionStorage.getItem('token');
    const id = sessionStorage.getItem('id_user');
    const access = sessionStorage.getItem('access');

    const isAdmin = access && (access.includes('admin') || access.includes('Admin'));

    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
            <Link className="navbar-brand" to="https://webdemo.afribonemali.net/rapport/frontend" style={{ width: '13%' }}>
                <img src="https://webdemo.afribonemali.net/rapport/frontend/logo.png" alt="Mon image" style={{ width: '70%' }} />
            </Link>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>

            {id && (
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <Link className="nav-link" to={url + 'rapport'}>Rapport</Link>
                        </li>
                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                Utilisateur
                            </a>
                            <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                <li><Link className="dropdown-item" to={url + 'profil/' + id}>Profil</Link></li>
                                {isAdmin && <li><Link className="dropdown-item" to={url + 'user'}>Liste des utilisateurs</Link></li>}
                            </ul>
                        </li>
                        {isAdmin && <li className="nav-item"><Link className="nav-link" to={url + 'role'}>Rôle</Link></li>}
                    </ul>

                </div>
            )}


            {token && (
                <div className="float-right me-2">
                    <Link className="btn btn-primary" to={url + 'logout'}>Déconnexion</Link>
                </div>
            )}
        </nav>
    );
}

export default Navbar;
